import { format } from 'date-fns';

//Search through orderItems for the first item which is an appointment item, return its SKU
export function determineAppointmentSku(orderItems) {
    const consultItem = orderItems?.find((item) => item.itemCategory === 'CLINICAL_CONSULTS');

    return consultItem?.sku;
}

//Formats an appointment for display in the appointment reminders
export function formatAppointmentForDisplay(appointment) {
    if (!appointment) return { name: null, start: null, timeframe: null };

    const name = appointment.appointmentType;
    const start = format(new Date(appointment.startAt), 'EEEE M/d h:mm a');
    const timeframe = `${format(new Date(appointment.startAt), 'h:mm')}-${format(
        new Date(appointment.endAt),
        'h:mm a (z)',
    )}`;

    return { name, start, timeframe };
}

export function findMostRecentByCreatedAt(array) {
    if (!Array.isArray(array) || array.length === 0) return null;

    function isValidItem(item) {
        return (
            item &&
            typeof item === 'object' &&
            'createdAt' in item &&
            !isNaN(new Date(item.createdAt).getTime())
        );
    }

    return array.reduce((latest, item) => {
        if (!isValidItem(item)) return latest;
        if (!latest) return item;

        const latestDate = new Date(latest.createdAt);
        const itemDate = new Date(item.createdAt);
        return itemDate > latestDate ? item : latest;
    }, null);
}
